export const INIT_IDENTIFY_TIMER = 'INIT_IDENTIFY_TIMER'
export const CLEAR_IDENTIFY_TIMER = 'CLEAR_IDENTIFY_TIMER'
export const UPDATE_IDENTIFY_TIMER = 'UPDATE_IDENTIFY_TIMER'
export const ADD_POPUP = 'ADD_POPUP'
export const CLEAR_POPUP = 'CLEAR_POPUP'



// WEBPACK FOOTER //
// ./src/logic/common/mutation-types.js